/**
 * Moodle OAuth2 Authentication Helper Functions
 */

/**
 * Initiate Moodle OAuth2 login by redirecting to backend endpoint
 * The backend handles all OAuth configuration and redirects to Moodle
 */
export function redirectToMoodleLogin(): void {
  // Backend endpoint will redirect to Moodle with proper OAuth parameters
  // This keeps ALL OAuth configuration on the backend (client_id, redirect_uri, etc.)
  const backendUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
  window.location.href = `${backendUrl}/api/auth/moodle`;
}

/**
 * Handle Moodle OAuth callback with token
 * @param token - JWT access token from backend
 */
export function handleMoodleCallback(token: string): void {
  if (token) {
    // Store token in localStorage
    localStorage.setItem('auth_token', token);
  }
}
